const config = {
  APP_NAME: 'My Aldoo-Ra Project',
  API_URL: "", // leave it empty to use the app domain
  // Where the client analytics session and its event batches are posted.
  // Empty means the platform API itself (POST {PLATFORM_API_URL}/v1/analytics),
  // which is where they belong unless a deployment runs a separate collector.
  ANALYTICS_URL: "",
  SUPPORT_CHAT_API: "",
  SUPPORT_EMAIL: "", // shown as the "contact support" link on sign-in; hidden when empty
  CMS_STATIC_URL: "",

  // Encryption configuration
  ENCRYPTION_ENABLED: false, // Start disabled for gradual rollout
  INFLIGHT_ENCRYPTION_KEY: "", // Same key as backend

  // Talk with the platform users
  PLATFORM_API_URL: 'http://localhost:7046',
  // Optional: used only by SSR (server-side) to bypass the public domain
  // (and the CDN) and reach the REST API over loopback. Leave empty in
  // local/dev where PLATFORM_API_URL already points at localhost. In
  // production, set to e.g. 'http://127.0.0.1:<API_PORT>' via deployment.js.
  INTERNAL_API_URL: '',
  PLATFORM_API_VERSION: 'v1',
  STRIPE_API_KEY: 'pk_test_your_stripe_key_here',

  // GTM Integration
  GTM_ID: "", // replace with your GTM container ID

  FACEBOOK_PIXEL: false,
  FACEBOOK_OPTIONS: "",
  TRACKING_GDPR: false,

  //If true will print additional information on api calls that respond with an error object
  API_DIAGNOSTICS: false,

  // The computer's address on the local network (e.g. "192.168.1.20"): a QR
  // code made on localhost ("sign with your phone") points the phone there.
  // Empty: the page's own origin.
  LOCAL_NETWORK_ADDRESS: "",

}

export default config